import { CustomerEntriesState } from "../store/customer_entries_state";
import { Reducer } from "redux";
import {
  CustomerEntriesAction,
  CustomerEntriesActionType,
  ICallbackGetEntryProjectsAction,
} from "../action/customer_entries_action";

const initialState: CustomerEntriesState = {
  projects: [],
  projectCount: 0,
  companiesWithProjectID: [],
  isLoading: false,
  contractIndex: {},
};

const customerEntriesReducer: Reducer<CustomerEntriesState> = (
  state = initialState,
  action: CustomerEntriesAction
): CustomerEntriesState => {
  switch (action.type) {
    case CustomerEntriesActionType.REQUEST_GET_ENTRY_PROJECTS: {
      return Object.assign({}, state, {
        projects: state.projects,
        projectCount: state.projectCount,
        companiesWithProjectID: state.companiesWithProjectID,
        isLoading: true,
      });
    }
    case CustomerEntriesActionType.CALLBACK_GET_ENTRY_PROJECTS: {
      const _action = action as ICallbackGetEntryProjectsAction;
      if (action.isSuccess) {
        return Object.assign({}, state, {
          projects: _action.item ? _action.item.projects : [],
          projectCount: _action.item ? _action.item.projectCount : 0,
          companiesWithProjectID: _action.item
            ? _action.item.companiesWithProjectID
            : [],
          isLoading: false,
          contractIndex: _action.item ? _action.item.contractIndex : {},
        });
      } else {
        return Object.assign({}, state, {
          projects: state.projects,
          projectCount: state.projectCount,
          companiesWithProjectID: state.companiesWithProjectID,
          isLoading: false,
          contractIndex: state.contractIndex,
        });
      }
    }

    default:
      return state;
  }
};

export default customerEntriesReducer;



// WEBPACK FOOTER //
// ./src/presentation/reducer/customer_entries_reducer.ts